import { motion } from "framer-motion";
import { CHAPTERS, IMAGES, SHOW_MEDIA } from "../../data";
import { Reveal } from "./Reveal";

export default function Story() {
  return (
    <section id="historia" className="relative bg-ink text-white py-24 md:py-36 overflow-hidden grain" data-testid="story">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-accent font-semibold mb-5">A nossa história</p>
                <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl leading-[1.02]">
                  Paixão pela<br /><span className="font-serif-ed italic font-medium text-accent">arte</span> de limpar.
                </h2>
              </Reveal>
              {SHOW_MEDIA && (
              <Reveal delay={0.15}>
                <div className="mt-8 relative aspect-[4/5] w-full max-w-sm overflow-hidden rounded-[1.5rem]">
                  <motion.img src={IMAGES.texture} alt="A arte de limpar vidros" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
                </div>
              </Reveal>
              )}
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="grid grid-cols-12 gap-4 border-t border-white/15 py-10 md:py-14">
                  <span className="col-span-2 font-serif-ed italic text-4xl md:text-6xl text-accent">{c.n}</span>
                  <div className="col-span-10">
                    <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mb-4">{c.title}</h3>
                    <p className="text-white/70 md:text-lg leading-relaxed max-w-xl">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
      <div className="hidden md:block pointer-events-none absolute -right-32 top-1/3 h-[500px] w-[500px] rounded-full bg-royal/30 blur-[70px]" />
    </section>
  );
}
